import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, assetUrl, formatErr, getVisitorId, mergeBranding, mergeForm } from "@/lib/api";
import { PublicError } from "@/components/PublicShell";
import { LandingPage } from "@/components/LandingPage";
import { ThankYouScreen } from "@/components/ThankYouScreen";

export default function Landing() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [c, setC] = useState(null);
  const [missing, setMissing] = useState(false);
  const [thanked, setThanked] = useState(false);

  useEffect(() => {
    api.get(`/public/campaigns/${slug}`).then((r) => {
      setC(r.data);
      document.title = r.data.title;
      api.post(`/public/campaigns/${slug}/visit`, {
        visitor_id: getVisitorId(), page: "landing", referrer: document.referrer,
        utm_source: params.get("utm_source") || "", utm_medium: params.get("utm_medium") || "", utm_campaign: params.get("utm_campaign") || "",
      }).catch(() => {});
    }).catch(() => setMissing(true));
  }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps

  const hubReturn = params.get("hub") && params.get("return") === "1";
  const goToContent = () => nav(hubReturn ? `/h/${params.get("hub")}` : `/c/${slug}/${c.campaign_type === "whitepaper" ? "read" : "watch"}`);

  const submit = async ({ email, answers, optins, legal_agreed }) => {
    try {
      const { data } = await api.post(`/public/campaigns/${slug}/lead`, { email, answers, optins, legal_agreed, visitor_id: getVisitorId() });
      localStorage.setItem(`sv_lead_${slug}`, data.lead_id);
      if (params.get("hub")) localStorage.setItem(`sv_hub_email_${params.get("hub")}`, email);
      if (c.cta_action === "download" && c.campaign_type === "whitepaper" && c.assets?.[0]) {
        const a = document.createElement("a");
        a.href = `${assetUrl(c.assets[0].file_path)}?download=true`;
        a.click();
        sessionStorage.setItem(`sv_dl_${slug}`, "1");
      }
      if (c.thank_you?.enabled) { setThanked(true); window.scrollTo(0, 0); return; }
      goToContent();
    } catch (ex) {
      throw new Error(formatErr(ex));
    }
  };

  if (missing) return <PublicError text="This campaign isn't available." />;
  if (!c) return <div className="min-h-screen grid place-items-center bg-[#070709]"><Loader2 className="w-6 h-6 animate-spin text-pink-400" /></div>;

  const campaign = { ...c, branding: mergeBranding(c.branding), form: mergeForm(c.form) };
  if (thanked) return <ThankYouScreen campaign={campaign} onContinue={goToContent} />;

  return (
    <div data-testid="landing-page">
      <LandingPage campaign={campaign} onSubmit={submit} />
    </div>
  );
}
